import difference from 'lodash/difference';
import find from 'lodash/find';

export default {
  _getOptions() {
    return this.isSearch ? this.filteredOptions : this.options;
  },

  _getPage(page) {
    const options = this._getOptions();
    const totalPages = Math.ceil(options.length / this.perPage);
    const from = (page ? page - 1 : 0) * this.perPage;
    const to = page * this.perPage;

    const res = {
      page: page,
      perPage: this.perPage,
      total: options.length,
      totalPages: totalPages,
      data: options.slice(from, to)
    };

    this.hasNextPage = page < totalPages;
    this.currentPage = page;

    return res;
  },

  _getNextPage() {
    if (!this.hasNextPage) return null;

    this.currentPage++;
    return this._getPage(this.currentPage);
  },

  _ensureHiddenOptions(data) {
    const $list = $('.q-hidden-inputs', this.$component);

    const selectedOptions = this.selectedValues
      .map(value => {
        return find(this.options, opt => {
          const val = opt[this.valueField] || opt.toString();
          return val.toString() === value.toString();
        });
      })
      .filter(value => value);

    const hiddenOptions = difference(selectedOptions, this.renderedValues);

    if (!data.length || !hiddenOptions.length) {
      $list.html('');
      return;
    }

    const html = hiddenOptions.map(opt => {
      const value = (opt[this.valueField] || opt.toString).toString().trim();
      const text = (opt[this.textField] || opt).toString().trim();

      return `
        <input type="${ this.multiple ? 'checkbox' : 'radio' }"
          name="${ this.name }${ this.multiple ? '[]' : '' }"
          value="${ value }"
          data-summary-label="${ this.placeholder }"
          data-summary-display="${ text.trim() }"
          checked>`;
    });

    $list.html(hiddenOptions.length ? html : '');
  }
};
